module.exports = __webpack_public_path__ + "img/logo_48_aes_marque.fb5c4479.svg";